import EmptyStates from './empty-states';
import EmptyStatesDesktop from './empty-states-desktop';
import forDevice from '../../hoc/for-device';

export default forDevice(EmptyStates, EmptyStatesDesktop);
